module.exports = __webpack_public_path__ + "img/resource-tech-image-33.f5dbfcba.jpg";